import { getStopApi } from '../../../services/StopApi/StopApi';

export const getReportList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      total: response?.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        id: index,
        rptId: item.rptId,
        reportTitle: item.reportTitle,
      })),
    };
  }).catch((e) => alert(e));
};

export const getWeeklyReport = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    return {
      isLoading: false,
      total: response?.totalRows,
      data: response.data.weeklyByCounty,
    };
  }).catch((e) => alert(e));
};

export const getDirectoryReport = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    return {
      isLoading: false,
      total: response?.totalRows,
      data: response.data.directory,
    };
  }).catch((e) => alert(e));
};

export const getAuthorizationListReport = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    return {
      isLoading: false,
      data: response.data,
    };
  }).catch((e) => alert(e));
};

export const getAuthorizationReportsCalomsact = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    return {
      isLoading: false,
      data: response,
    };
  }).catch((e) => alert(e));
};